import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { find } from 'lodash-es'
import ActionTypes from '@constants/action_types.js'

const horizontalTimelineViewsAdapter = createEntityAdapter()

// create initial state for the views slice and include a view to act as the default view
const initialState = horizontalTimelineViewsAdapter.getInitialState({
  ids: [],
  entities: {},
})

const slice = createSlice({
  name: 'horizontalTimelineViews',
  initialState,
  extraReducers: builder => {
    builder.addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => {
      const { payload } = action
      if (payload.hasOwnProperty('horizontal_timeline_views')) {
        horizontalTimelineViewsAdapter.upsertMany(state, payload.horizontal_timeline_views)
      }
    })
  },
})

// Selectors

export const horizontalTimelineViewsSelectors = horizontalTimelineViewsAdapter.getSelectors(
  state => state.data.horizontalTimelineViews
)

export const getHorizontalTimelineView = (state, props) => {
  const { horizontalTimelineViewId } = props
  const allEntities = horizontalTimelineViewsSelectors.selectAll(state)
  return find(allEntities, entity => {
    const result = entity.id.toString() === horizontalTimelineViewId.toString()
    return result
  })
}

export default slice.reducer
